<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte"

  export let step: string

  const dispatch = createEventDispatcher()

  let steps: any = [
    {
      id: "get_started",
      sub_steps: ["welcome", "founders_message", "your_profile"]
    },
    {
      id: "essentials",
      sub_steps: ["plan_setup", "departments", "invite_members"]
    },
    {
      id: "one_page_view",
      sub_steps: ["overview", "brand_purpose", "values", "blue_sky_vision"]
    },
    {
      id: "SWOT",
      sub_steps: ["strengths", "weaknesses", "opportunities", "threats"]
    },
    {
      id: "Goals",
      sub_steps: ["goal_overview"]
    }
  ]

  const titleCase = (s) =>
    s
      .replace(/^[-_]*(.)/, (_, c) => c.toUpperCase()) // Initial char (after -/_)
      .replace(/[-_]+(.)/g, (_, c) => " " + c.toUpperCase()) // First char after each -/_

  function getCurrentStepNum() {
    return steps.findIndex((s) => {
      let found = s.sub_steps.find((el) => el === step)
      if (found) {
        return true
      }
    })
  }

  let current_step_num = 0

  let sub_steps = []
  let current_sub_step = 0

  function updateStep(step) {
    dispatch("updateStep", step)
  }

  onMount(async () => {
    current_step_num = getCurrentStepNum()
    sub_steps = steps[current_step_num].sub_steps

    current_sub_step = sub_steps.findIndex((s) => {
      return s === step
    })
  })
</script>

<nav class="flex" aria-label="Breadcrumb">
  <ol class="flex items-center space-x-0 md:space-x-1">
    {#each steps as { id }, index}
      <li>
        <div
          class={index <= current_step_num
            ? "flex items-center text-white font-bold"
            : "flex items-center text-gray-400"}
        >
          {#if index > 0}
            <svg
              class="flex-shrink-0 h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          {/if}
          {#if index < current_step_num}
            <a
              href={"#"}
              on:click={() => updateStep(id)}
              class:ml-1={index > 0}
              class="text-sm leading-tight md:leading-normal md:text-base font-medium whitespace-nowrap"
            >
              {titleCase(id)}
            </a>
          {:else if index == current_step_num}
            <span
              class="text-base leading-tight md:leading-normal md:text-xl font-bold whitespace-nowrap"
            >
              {titleCase(id)}
            </span>
          {:else}
            <span
              class:ml-1={index > 0}
              class="text-xs leading-tight md:leading-normal md:text-sm font-medium whitespace-nowrap"
            >
              {titleCase(id)}
            </span>
          {/if}
        </div>
      </li>
    {/each}
  </ol>
</nav>
<nav
  class="flex border-t border-gray-400 py-2 mt-2 ml-1 items-center"
  aria-label="SubSteps"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="h-6 w-6 mx-2 text-white"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="2"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M13 5l7 7-7 7M5 5l7 7-7 7"
    />
  </svg>
  <ol class="flex items-center space-x-0 md:space-x-1">
    {#each sub_steps as sub_step, index}
      <li>
        <div
          class={index <= current_sub_step
            ? "flex items-center text-white font-bold"
            : "flex items-center text-gray-400"}
        >
          {#if index > 0}
            <svg
              class="flex-shrink-0 h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          {/if}

          {#if index < current_sub_step}
            <span
              class="text-xs leading-tight md:leading-normal md:text-sm font-medium whitespace-nowrap"
            >
              {titleCase(sub_step)}
            </span>
          {:else if index == current_sub_step}
            <span
              class="text-xs leading-tight md:leading-normal md:text-base font-bold whitespace-nowrap"
            >
              {titleCase(sub_step)}
            </span>
          {:else}
            <span
              class="text-xs leading-tight md:leading-normal md:text-sm font-medium whitespace-nowrap"
            >
              {titleCase(sub_step)}
            </span>
          {/if}
        </div>
      </li>
    {/each}
  </ol>
</nav>
